const BarcodeConfigurationFormValues = {
  formName: "BarcodeConfigurationForm",
  formMethod: "POST",
  cancelAction: "MasterListsPage",
  submitOnCancel: false,
  cancelMethod: "POST",
  numMaxOrderLabels: 0,
  numMaxSpecimenLabels: 0,
  numMaxAliquotLabels: 0,
  numMaxSlideLabels: 0,
  numMaxBlockLabels: 0,
  numMaxFreezerLabels: 0,
  numDefaultOrderLabels: 0,
  numDefaultSpecimenLabels: 0,
  numDefaultAliquotLabels: 0,
  numDefaultSlideLabels: 0,
  numDefaultBlockLabels: 0,
  numDefaultFreezerLabels: 0,
  heightOrderLabels: 0,
  widthOrderLabels: 0,
  heightSpecimenLabels: 0,
  widthSpecimenLabels: 0,
  heightBlockLabels: 0,
  widthBlockLabels: 0,
  heightSlideLabels: 0,
  widthSlideLabels: 0,
  heightFreezerLabels: 0,
  widthFreezerLabels: 0,

  orderPatientDobCheck: true,
  orderPatientIdCheck: true,
  orderPatientNameCheck: true,
  orderSiteIdCheck: true,
  specimenPatientDobCheck: true,
  specimenPatientIdCheck: true,
  specimenPatientNameCheck: true,
  specimenCollectionDateCheck: true,
  specimenCollectedByCheck: true,
  specimenTestsCheck: true,
  specimenPatientSexCheck: true,
  slidePatientIdCheck: true,
  slideSlideIdCheck: true,
  slideStainTypeCheck: true,
  slideBlockIdCheck: true,
  slideCaseNumberCheck: true,
  blockPatientIdCheck: true,
  blockBlockIdCheck: true,
  blockSpecimenTypeCheck: true,
  blockCaseNumberCheck: true,
  freezerPatientIdCheck: true,
  freezerStorageLocationCheck: true,
  freezerSpecimenTypeCheck: true,
  freezerCollectionDateCheck: true,
  freezerExpiryDateCheck: true,

  prePrintDontUseAltAccession: true,
  prePrintAltAccessionPrefix: "",
};

export default BarcodeConfigurationFormValues;
